import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const EllipsisHorizontalIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/ellipsis-horizontal"><g id="Icon"><path d="M3.59998 12.0002C3.59998 11.0061 4.40586 10.2002 5.39998 10.2002C6.39409 10.2002 7.19998 11.0061 7.19998 12.0002C7.19998 12.9943 6.39409 13.8002 5.39998 13.8002C4.40586 13.8002 3.59998 12.9943 3.59998 12.0002Z" fill="currentColor" /><path d="M10.2 12.0002C10.2 11.0061 11.0059 10.2002 12 10.2002C12.9941 10.2002 13.8 11.0061 13.8 12.0002C13.8 12.9943 12.9941 13.8002 12 13.8002C11.0059 13.8002 10.2 12.9943 10.2 12.0002Z" fill="currentColor" /><path d="M18.6 10.2002C17.6059 10.2002 16.8 11.0061 16.8 12.0002C16.8 12.9943 17.6059 13.8002 18.6 13.8002C19.5941 13.8002 20.4 12.9943 20.4 12.0002C20.4 11.0061 19.5941 10.2002 18.6 10.2002Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default EllipsisHorizontalIcon;